// extracted by mini-css-extract-plugin
export default {"additionalIcon":"PanelCollection_additionalIcon__qLxVh","visible":"PanelCollection_visible__LU8xu"};